import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { GlobalService } from '@23degrees/shared/services/global/global.service';
import { AuthQuery } from '@23degrees/stores/auth/auth.query';

/**
 * Rules access for the whole plattform this
 * is the place to check if user has access to
 * a page in general
 */
@Injectable({
  providedIn: 'root',
})
export class CreateGuard {
  private router = inject(Router);
  private authQuery = inject(AuthQuery);
  private globalService = inject(GlobalService);

  private isServer = this.globalService.isServer();

  public canActivate = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any => {
    return this.checkUserPermission(route, state);
  };

  public canActivateChild = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any => {
    return this.checkUserPermission(route, state);
  };

  private checkUserPermission = async (route, state) => {
    try {
      // if (this.isServer) {
      //   return true;
      // }

      return true;
    } catch (error) {
      // throw error;
      console.log('[CreateGuard] error ', error);
      return false;
    }
  };
}
